module.exports = __webpack_public_path__ + "img/x3.d2641dd0.png";